import { FormattedMessage, useIntl } from "react-intl";

import { DEFAULT_VALUES, useLocalizedHref } from "@/libraries/web-framework";

const AnonymousAccessSpork = () => {
    const intl = useIntl();

    const messages = {
        title: intl.formatMessage({
            id: "jira-software-pricing.modal-content.anonymous-access-spork.title",
            defaultMessage: "Anonymous access"
        }),
        body: intl.formatMessage({
            id: "jira-software-pricing.modal-content.anonymous-access-spork.body",
            defaultMessage:
                "Anonymous access lets people outside of your organization view and create issues without logging in. Allow external partners to see work in progress on joint projects or give customers the ability to submit bugs and feature requests."
        })
    };

    return (
        <div>
            <h2>{messages.title}</h2>
            <p>{messages.body}</p>
            <p>
                <FormattedMessage
                    id="JiraSoftwarePricingPage.modalContents.anonymous-access-spork.learnMore"
                    defaultMessage="<learnMore>Learn more</learnMore> about anonymous access."
                    values={{
                        ...DEFAULT_VALUES,
                        learnMore: (chunks) => (
                            <a
                                data-event="clicked"
                                data-event-component="linkButton"
                                data-product-key="jiraSoftware"
                                // eslint-disable-next-line react-hooks/rules-of-hooks
                                href={`https://support.atlassian.com${useLocalizedHref(
                                    "/jira-cloud-administration/docs/allow-anonymous-access-to-projects/"
                                )}`}
                            >
                                {chunks}
                            </a>
                        )
                    }}
                />
            </p>
        </div>
    );
};

export default AnonymousAccessSpork;
